import { confirmRegisterAPI } from "../../apis/otpApis"
import {
  ConfirmRegisterSuccess,
  requestFail,
  requestPending,
} from "./confirmRegistrationSlice"

export const confirmRegisterAction = (fmdt) => async (dispatch) => {
  try {
    dispatch(requestPending())
    const data = await confirmRegisterAPI(fmdt)
    dispatch(ConfirmRegisterSuccess(data))
  } catch (error) {
    const err = {
      status: "error",
      message: error.message,
    }
    dispatch(requestFail(err))
  }
}
